export function Credicts() {
  const style = {
    fontSize: 10,
    fontStyle: 'italic',
    marginTop: 20
  };

  return (
    <div style={style}>By <a href="https://github.com/thiagobitencourt" target="_blank" rel="noreferrer">Thiago Bitencourt</a></div>
  );
}